import apiHandler from "./apiHandler";

export const LoginApiHandler = {
    loginWithToken: function (req) {
        var url = "login/validate-token";
        return apiHandler.post(url, req);
    }
};

export const getAttributes = function (params) {
    var url = "santa-attribute";
    return apiHandler.get(url,params);
};

export const getCategoryData = function () {
    var url = "product-segment/category";
    return apiHandler.get(url)
}

export const requestCampaign = function (body) {
    var url = "santa-campaign/request"
    return apiHandler.post(url, body)
}

export const pauseResumeUpdateCampaign = function (body) {
    var url = "santa-campaign"
    return apiHandler.put(url, body)
}

export const getCampaignListApi = function (params) {
    var url = "santa-campaign";
    return apiHandler.get(url, params)
}

export const getCampaignSummaryApi = function (id) {
    var url = `santa-campaign/${id}`;
    return apiHandler.get(url);
}

export const getCampaignsCountApi = (params) => {
    const url = 'santa-campaign/count';
    return apiHandler.get(url, params)
}

export const getProductSegment = function (params) {
    var url = "santa-attribute";
    return apiHandler.get(url, params)
}

export const createSegment = function (body) {
    var url = "segment"
    return apiHandler.post(url, body)
}

export const postSegmentList = function (body) {
    var url = "segment/fetch";
    return apiHandler.post(url, body)
}

export const getCustomerCountApi = function (body) {
    var url = "rule/get-customers-count";
    return apiHandler.post(url, body)
}